export const LOCAL_LIBRARY_ID = 'local-library'

const LOCAL_MODE_KEY = 'framex.storage.mode'
const LAST_ACTIVITY_KEY = 'framex.localLibrary.lastActivity'
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

export function rememberLocalMode(): void {
  try {
    localStorage.setItem(LOCAL_MODE_KEY, 'local')
    localStorage.setItem(LAST_ACTIVITY_KEY, new Date().toISOString())
  } catch (error) {
    console.warn('Unable to persist local mode preference:', error)
  }

  try {
    document.cookie = `${LOCAL_MODE_KEY}=local; Max-Age=${COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax`
  } catch (error) {
    console.warn('Unable to write local mode cookie:', error)
  }
}

export function getLocalModePreference(): string | null {
  try {
    return localStorage.getItem(LOCAL_MODE_KEY)
  } catch {
    return null
  }
}

export function writeLocalJson<T>(key: string, value: T): void {
  localStorage.setItem(key, JSON.stringify(value))
}

export function readLocalJson<T>(key: string, fallback: T): T {
  try {
    const value = localStorage.getItem(key)
    return value ? JSON.parse(value) as T : fallback
  } catch {
    return fallback
  }
}